import { disableFragmentWarnings } from 'graphql-tag';
disableFragmentWarnings(); // disables gql fragment warnings - needs to be (possibly only) here, since this lib compiles first

export * from './lib';
